import { __extends, __assign } from 'tslib';
import React__default from 'react';
import clsx from 'clsx';
import { propTypes, defaultProps } from './Card.types.js';
import styles from './Card.module.scss.js';

var Card = /** @class */ (function (_super) {
    __extends(Card, _super);
    function Card() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onCardClick = function (e) {
            var onClick = _this.props.onClick;
            if (onClick) {
                onClick(e);
            }
        };
        return _this;
    }
    Card.prototype.render = function () {
        var _a = this.props, children = _a.children, className = _a.className, elevation = _a.elevation, onClick = _a.onClick;
        var cardShadow = styles["Card___elevation" + (elevation < 0 ? "Negative" + Math.abs(elevation) : elevation)];
        return (React__default.createElement("div", { "data-testid": this.props['data-testid'], className: clsx(styles.Card, cardShadow, onClick && styles.Card___hoverable, className), onClick: this.onCardClick }, children));
    };
    Card.displayName = 'Card';
    Card.propTypes = propTypes;
    Card.defaultProps = __assign({}, defaultProps);
    return Card;
}(React__default.Component));

export { Card, Card as default };
